/* Step 17: reveal .product-sticky-bar on mobile after user scrolls past
 * the main #AddToCart button. No-op on desktop (CSS hides the bar there).
 */
(function () {
  'use strict';
  function init() {
    var bar = document.querySelector('.product-sticky-bar');
    var atc = document.getElementById('AddToCart');
    if (!bar || !atc) return;
    function check() {
      // Only apply scroll behaviour on mobile widths
      if (window.matchMedia('(min-width: 768px)').matches) {
        bar.classList.remove('is-revealed');
        return;
      }
      var rect = atc.getBoundingClientRect();
      bar.classList.toggle('is-revealed', rect.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
